import { JtiDocumentAdditionalInfoForBoolean } from './jti-document-additional-info-for-boolean.model';
import { JtiDocumentAdditionalInfoForText } from './jti-document-additional-info-for-text.model';
import { JtiDocumentAdditionalInfoForDate } from './jti-document-additional-info-for-date.model';
import { JtiDocumentAdditionalInfoForCurrency } from './jti-document-additional-info-for-currency.model';
import { JtiDocumentAdditionalInfoForNewAddress } from './jti-document-additional-info-for-new-address.model';
import { JtiDocumentAdditionalInfoForSelfRepresented } from './jti-document-additional-info-for-self-represented.model';
import { ChangeAddress } from './change-address.model';

export class JtiDocumentAdditionalInfo
{
  code: string;
  name: string;
  filter: string;
  required: boolean;
  valueRestriction: string;
  classType: string;
  subType: string;
  additionalInfoTags: string;
}
export class JtiDocumentAdditionalInfoMetaTags
{
  code: string;
  name: string;
  filter: string;
  required: boolean;
  valueRestriction: string;
  classType: string;
  subType: string;
  additionalInfoTags: string;
  value:string;
}
export class DocumentFilingMetaDataItem
{
  jtiDocumentAdditionalInfoForAsToList: JtiDocumentAdditionalInfoMetaTags[];
  jtiDocumentAdditionalInfoForNotAsTo: JtiDocumentAdditionalInfoMetaTags[];
  jtiDocumentAdditionalInfoForFiledByList: JtiDocumentAdditionalInfoMetaTags[];
  jtiDocumentAdditionalInfoForNewAsToList: JtiDocumentAdditionalInfoMetaTags[];
  jtiDocumentAdditionalInfoForNewFiledByList: JtiDocumentAdditionalInfoMetaTags[];
  jtiDocumentAdditionalInfoForExistingAttorneyList:JtiDocumentAdditionalInfoMetaTags[];
  jtiDocumentAdditionalInfoForNewAttorney: JtiDocumentAdditionalInfoMetaTags[];
  jtiDocumentAdditionalInfoForBooleansList: JtiDocumentAdditionalInfoForBoolean[];
  jtiDocumentAdditionalInfoForTextList: JtiDocumentAdditionalInfoMetaTags[];
  jtiDocumentAdditionalInfoForDateList: JtiDocumentAdditionalInfoMetaTags[];
  jtiDocumentAdditionalInfoForCurrencyList: JtiDocumentAdditionalInfoMetaTags[];
  jtiDocumentAdditionalInfoForCodeLists: JtiDocumentAdditionalInfoMetaTags[];
  jtiDocumentAdditionalInfoForAddnewAddressList: JtiDocumentAdditionalInfoForNewAddress;
  jtiDocumentAdditionalInfoForSelfRepresented: ChangeAddress[];
}